import { format } from "date-fns";
import { ArrowRepeat, CheckSquare } from "react-bootstrap-icons";
import { cn } from "@utils";
import { defaultChipStyle, projectionIdentity, statusChipStyles, taskChipStyle } from "../common";

// One row per calendar item: [icon] [time] [label] … [account code]. The label truncates first so the
// code stays pinned to the right and the codes line up down the column. `item.accountCode` is resolved
// up front by the calendar page (Calendar.jsx / useCustomerAccountCodes) — a projection's feed
// reference, or the linked customer's account code — so the chip stays a pure render.
const EventChip = ({ item, onClick, showTime = true }) => {
  const identity = projectionIdentity(item);
  const isTask = !identity && item.kind === "task";

  const { instalment, instalmentTotal } = item.projection ?? {};
  const code = item.accountCode ?? null;

  // Tasks anchor on their due date, not a start — read the time from whichever the item has.
  const anchor = item.start ?? item.due;
  const time = !item.allDay && anchor ? format(anchor, "HH:mm") : null;

  const Icon = identity?.Icon ?? (isTask ? CheckSquare : null);
  const position = instalment && instalmentTotal ? ` ${instalment}/${instalmentTotal}` : "";
  const label = identity ? `${identity.label}${position}` : item.summary || "(no title)";

  const style = identity
    ? identity.chip
    : isTask && item.status !== "COMPLETED" && item.status !== "CANCELLED"
      ? taskChipStyle
      : statusChipStyles[item.status] ?? defaultChipStyle;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(item);
      }}
      className={cn(
        "flex w-full items-center gap-1 rounded-md px-2 py-1 text-left text-xs font-medium transition-colors",
        style,
        item.ownerColorClass && `border-l-4 ${item.ownerColorClass}`,
      )}
      title={[item.ownerLabel, time, label, code].filter(Boolean).join(" · ")}
    >
      {Icon && <Icon className="size-3.5 shrink-0" />}
      {showTime && time && <span className="shrink-0 tabular-nums opacity-70">{time}</span>}
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {item.rrule && <ArrowRepeat className="size-3 shrink-0 opacity-60" />}
      {code && <span className="shrink-0 pl-1 tabular-nums opacity-70">{code}</span>}
    </button>
  );
};

export default EventChip;
